export default __webpack_public_path__ + "static/media/resources.572e4e2f.wav";